// @ts-nocheck
import getWindow from './getWindow'

/**
 * Get the viewed (current) location path.
 * @return {string} Viewed page URL path
 */
export function getViewedPagePath() {
  const viewedUrl = getWindow('location.href') || ''
  const url = viewedUrl ? new URL(viewedUrl) : { pathname: '' }
  return url.pathname
}

/**
 * Extract current viewed page Query String parameters.
 * @return {Object<string, any>}
 */
export function getViewedPageParams() {
  const viewedUrl = getWindow('location.href') || ''
  const params = {}

  new URL(viewedUrl).searchParams.forEach(function (val, key) {
    if (params[key] !== undefined) {
      if (!Array.isArray(params[key])) {
        params[key] = [params[key]]
      }
      params[key].push(val)
    } else {
      params[key] = val
    }
  })

  return params
}
